import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeUpdateGeneralAttestationMutation as useDeUpdateGeneralAttestationMutationType } from "@/modules/patients/detail/general-attestation/de/services/__generated__/useDeUpdateGeneralAttestationMutation.graphql"

const mutation = graphql`
  mutation useDeUpdateGeneralAttestationMutation($input: De_updateGeneralAttestationInput!) {
    de_updateGeneralAttestation(input: $input) {
      de_GeneralAttestation {
        id
        ...deGeneralAttestationsFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeUpdateGeneralAttestationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeUpdateGeneralAttestationMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeUpdateGeneralAttestationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeUpdateGeneralAttestationMutation }
